import React, { Component } from 'react';
import Checkbox from '../../portal/controls/checkbox';
import classNames from 'classnames';
import styles from './style.scss';

export default class CheckboxListItem extends Component {
  
    render() {

        const { imported } = this.props;

        return (
            <div className={
                        classNames(styles.checkboxListItemWrapper, 
                            this.props.checked && styles.selected,
                            imported && styles.imported)}
                            style={this.props.style}
            >
                <div className={classNames(styles.leftSelectedBorder)}></div>
                <div className={classNames(styles.checkbox)}>
                    <Checkbox
                        dataKey={this.props.dataKey}
                        checked={this.props.checked}
                        onCheck={this.props.toggle}
                        disabled={imported}
                    />
                </div>
                <table>
                    <tbody>
                        <tr>
                            <td className={classNames(styles.dirNameWrapper)}>
                                <span
                                    title={this.props.name}
                                    className={classNames(styles.dirName, imported && styles.imported)}>
                                        {this.props.name}
                                </span>
                            </td>
                            <td>
                                <div
                                    className={
                                        classNames(
                                                styles.groupNameWrapper,
                                                imported && styles.mapped,
                                                !imported && styles.ellipsis
                                            )
                                        }
                                >
                                    <div
                                        title={this.props.group}
                                        className={classNames(styles.groupName, imported && styles.imported, imported && styles.ellipsis)}>
                                            {this.props.group}
                                    </div>
                                    {
                                        imported 
                                            && <div
                                                    className={styles.mappedIndicator}
                                                    title={this.props.translations.mapped}
                                                >
                                                {this.props.translations.mapped}
                                               </div>
                                    }
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/components/teams/ldapMappingCheckboxListItem/index.jsx